"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _date = require("../../../utils/date");
var planeIcon = function planeIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#17181A",
    d: "M10.937 12.507l-3.323 2.038s-.882.686-2.545.343c-1.664-.343-3.37-.72-3.37-.72s-.365-.133-.618.194c-.252.326.163.521.163.521l2.566 1.858s.547.542 1.353.4c.805-.142 3.175-.623 3.175-.623s1.617-.346 3.54-1.545c1.924-1.2 8.8-5.372 8.8-5.372s2.675-1.521 2.407-2.158c-.268-.636-1.811-.466-2.549-.233-.737.233-6.494 3.496-6.494 3.496l-6.31-2.163s-.816-.194-.408.282c.408.477 4.406 4.456 4.406 4.456m1.564 2.263l1.714 1.71s.498.394.598-.979c.1-1.372.202-2.4.202-2.4"
  }));
};
planeIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var CancellationPolicyStageDate = function CancellationPolicyStageDate(props) {
  var dateISO = props.dateISO,
    mobile = props.mobile,
    last = props.last,
    firstStage = props.firstStage,
    firstWidest = props.firstWidest,
    secondWidest = props.secondWidest,
    empty = props.empty,
    isHotelOnly = props.isHotelOnly;
  if (firstStage) {
    return null;
  }
  if (empty) {
    return null;
  }
  if (mobile && last && !firstWidest && !secondWidest && !isHotelOnly) {
    return /*#__PURE__*/_react["default"].createElement(StyledLastDateRow, null, /*#__PURE__*/_react["default"].createElement(StyledPlaneIcon, null));
  }
  var format = isHotelOnly ? 'd MMM, HH:mm' : 'd MMM';
  return /*#__PURE__*/_react["default"].createElement(StyledDateRow, null, /*#__PURE__*/_react["default"].createElement(StyledStageDate, null, (0, _date.formatDate)(dateISO, format)), last && !isHotelOnly ? /*#__PURE__*/_react["default"].createElement(StyledPlaneIcon, null) : null);
};
var StyledStageDate = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDate__StyledStageDate",
  componentId: "sc-n3t287-0"
})(["font-size:12px;line-height:16px;margin-top:2px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLight;
});
var StyledDateRow = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDate__StyledDateRow",
  componentId: "sc-n3t287-1"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
var StyledPlaneIcon = (0, _styledComponents["default"])(planeIcon).withConfig({
  displayName: "CancellationPolicyStageDate__StyledPlaneIcon",
  componentId: "sc-n3t287-2"
})(["text-align:end;width:14px;margin-top:2px;> *{stroke:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greyLight;
});
var StyledLastDateRow = _styledComponents["default"].div.withConfig({
  displayName: "CancellationPolicyStageDate__StyledLastDateRow",
  componentId: "sc-n3t287-3"
})(["display:flex;justify-content:flex-end;"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(CancellationPolicyStageDate);